export const POST_IMAGE_SIZE = 450;
